import {Blend, DynamicColor, Hct, TonalPalette, argbFromHex, hexFromArgb, themeFromSourceColor} from "@material/material-color-utilities";

// Contrast ratio Malong uses when generating "on" colors for exact theme
// colors; keep in sync with getOnColor in malong/src/shared/themes/CustomTheme.tsx.
const ON_COLOR_CONTRAST_RATIO = 13;

// How much primary is blended into the surface for the elevated surface role.
const SURFACE_AT_4_TINT = 0.12;

// Generates the on color variant for a given color, same logic as malong
const onColor = (argb) => {
  const tone = Hct.fromInt(argb).tone;
  const foregroundTone = DynamicColor.foregroundTone(tone, ON_COLOR_CONTRAST_RATIO);
  return TonalPalette.fromInt(argb).tone(foregroundTone);
};

const colorsFor = (generated, { accent, exact }) => {
  let colors = {};

  Object.keys(window.Theme.COLORS).forEach((key) => {
    let generatedKey = key.replace(/-([a-z0-9])/g, (_, c) => c.toUpperCase());
    const generatedColor = generated[generatedKey];
    if (generatedColor === undefined) return;

    colors[key] = hexFromArgb(generatedColor);
  });

  if (exact) {
    const primary = argbFromHex(accent);
    colors["primary"] = hexFromArgb(primary);
    colors["on-primary"] = hexFromArgb(onColor(primary));
  }

  colors["surface-at-4"] = hexFromArgb(
    Blend.cam16Ucs(generated.surface, generated.primary, SURFACE_AT_4_TINT),
  );

  return colors;
};

const branding = () => {
  const source = document.querySelector("[data-branding-accent-color]");
  if (!source) return null;

  const { brandingAccentColor, brandingSecondaryColor, brandingExactColors } = source.dataset;

  return {accent: brandingAccentColor, secondary: brandingSecondaryColor, exact: brandingExactColors === "true"};
};

export const defineWebinarTheme = () => {
  const colors = branding();
  if (!colors) return;

  const schemes = themeFromSourceColor(argbFromHex(colors.accent), [
    { blend: false, name: "tertiary", value: argbFromHex(colors.secondary) },
  ]).schemes;

  window.Theme.define("webinar-light", colorsFor(schemes.light, colors));
  window.Theme.define("webinar-dark", colorsFor(schemes.dark, colors));
};

defineWebinarTheme();
